<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import OurGoal from "src/components/main/about/components/our-goal/OurGoal.svelte"
    import LisTokenUtility from "src/components/main/about/components/lis-token-utility/LisTokenUtility.svelte"
    import OurValues from "src/components/main/about/components/our-values/OurValues.svelte"
    import PlayersCan from 'src/components/main/about/components/players-can/PlayersCan.svelte'
    import LisToken from "src/components/main/about/components/lis-token/LisToken.svelte"
    import Roadmap from 'src/components/main/about/components/roadmap/Roadmap.svelte'
    import OurTeam from 'src/components/main/about/components/our-team/OurTeam.svelte'
    import Text from 'src/components/main/about/components/text/Text.svelte'
    import VisitCommunity from 'src/components/main/#common/visit-community/VisitCommunity.svelte'
</script>

<svelte:head>
    <title>About | Realis</title>
    <meta name="description" content="Our goal is to connect game economy with real world where users will be fully involved and become full owners of the platform and the games they play. We strive to provide players with the most immersive and enjoyable gaming experience possible."/>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <OurGoal/>
        <!--<LisTokenUtility/>-->
        <!--<OurValues/>-->
        <PlayersCan/>
        <!--<LisToken/>-->
        <Roadmap/>
        <OurTeam/>
        <Text/>
        <VisitCommunity/>
    </svelte:fragment>
</MainLayout>

